// extracted by mini-css-extract-plugin
export default {"section":"SectionLayout_section__LJ23L","tabs":"SectionLayout_tabs__-Pgd8","tab":"SectionLayout_tab__nZ0Ye","active":"SectionLayout_active__t2Y6a"};